import type { FaireProductEntity } from "../../entity_types/product";

export const p_3dze777h6z: FaireProductEntity = {
  token: "p_3dze777h6z",
  type: "product",
  name: "Boho Inspired Pearl Detail Hair Tie Bracelets",
  brandToken: "b_bya786doke",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/9ec25b96037534347618ec47085e32ddd10ca2a25c54e0c3fc170d5227ef6fcf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0699bfa48ecefe2a81b83f7a9275cfeb26cb357a888fbe461a51ed41d922f47.jpeg",
    "https://cdn.faire.com/fastly/918b58f4fd61bc546227b51f60afe0f1dfe19903733ab6b340a54bd0f1a68099.jpeg",
    "https://cdn.faire.com/fastly/85cf64b33aa1579865925e35053cd792654051d971a7874021a13188b2c66082.jpeg",
    "https://cdn.faire.com/fastly/53765a5420651494a211550c4ab624d0a43b962cf071f7222b749f4124ddb93e.jpeg",
    "https://cdn.faire.com/fastly/3a1c7531dfb5ed3ad260ce942fe9e6226a11ab89a78969abe0a256f7407ae940.jpeg",
    "https://cdn.faire.com/fastly/5531dac45017f1ba6b581a58eb5266697e613b36921fc818d36a447db1d328c9.jpeg",
    "https://cdn.faire.com/fastly/e8d428369a7ae8cdb491d1e300b5a86187641c3d9da0428f7e68ea2f1fd24f6b.jpeg",
  ],
  priceDollars: 1.95,
  description:
    "Boho Inspired Pearl Detail Hair Tie Bracelets\r\n\r\n-Hair Tie Bracelets for Women. Elastic Hair Bands That Double as Stylish Jewelry Inspire.\r\n-Multi-purpose: Wear as a hair tie or stack as trendy bracelets\r\n-5 Kinds per 1 card\r\n-3 Color theme combined specially made for Love and Repeat\r\n",
  tags: [],
  msrpDollars: 3.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:01.069Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
